import { defineRouteGroup } from './route-group';

export const ADMIN_FONT_ROUTES = defineRouteGroup('admin', {
  fonts: 'fonts',
});

export const FILES_FONT_ROUTES = defineRouteGroup('', {
  public: 'files/fonts/public',
  registration: 'files/fonts/registration',
  forDesigns: 'files/fonts/for-designs',
  forPhotobook: (photoBookId: string) => `files/fonts/for-photobook/${photoBookId}`,
  byId: (id: string) => `files/fonts/${id}`,
});

// The share token is the client link's credential; the answer is the `forPhotobook` context of the book owner.
export const CLIENT_BOOK_FONT_ROUTES = defineRouteGroup('client-books', {
  fonts: (token: string) => `${token}/fonts`,
});

export const FONTS_USER_ROUTES = defineRouteGroup('', {
  byFileId: (fileId: string) => `fonts/user/${fileId}`,
});

export const FONT_MAPPING_ROUTES = defineRouteGroup('font-mappings', {
  create: '',
  forDesigns: 'for-designs',
  byId: (id: string) => id,
});
